import http from '@/http/index'

// NEJM目录
export function newestArticle(params) {
  return http.post('/api/article/newestArticle', params)
}
